import React from 'react';
import classNames from 'classnames';

import css from './PricingPage.module.css';
import { H3, LayoutSingleColumn, Page } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import { compose } from 'redux';
import { FormattedMessage, useIntl } from 'react-intl';
import { connect } from 'react-redux';
import { getDomain } from '../../util/urlHelpers';

const phoneNumber = '+96894957876';

const PricingPageComponent = props => {
  const { scrollingDisabled } = props;
  const intl = useIntl();

  const title = intl.formatMessage({
    id: 'PricingPage.title',
  });

  const message = intl.formatMessage(
    { id: 'ListingCard.whatsAppLinkMsg' },
    { link: getDomain(process.env.REACT_APP_MARKETPLACE_ROOT_URL) }
  );
  const whatsAppMessage = encodeURIComponent(message);

  return (
    <Page title={title} scrollingDisabled={scrollingDisabled}>
      <LayoutSingleColumn topbar={<TopbarContainer />} footer={<FooterContainer />}>
        <div className={css.pageTitle}>
          <H3 as="h1" className={css.title}>
            <FormattedMessage id="PricingPage.heroTitle" />
          </H3>
          <p className={css.description}>
            <FormattedMessage id="PricingPage.heroDescription" />
          </p>
        </div>

        <div className={css.yearlyDiv}>
          <FormattedMessage id="PricingPage.yearly" />
        </div>

        <div className={css.pricingTypes}>
          {/* Basic Plan */}
          <div className={css.card}>
            <h3 className={css.planName}>
              <FormattedMessage id="PricingPage.basicPlan" />
            </h3>
            <p className={css.planSubtitle}>
              <FormattedMessage id="PricingPage.basicPlanSubTitle" />
            </p>

            <div className={css.priceRow}>
              <span className={css.price}>
                <FormattedMessage id="PricingPage.basicPrice" />
              </span>
              <span className={css.currency}>
                <FormattedMessage id="PricingPage.currencyPerMonth" />
              </span>
            </div>

            <button
              className={classNames(css.btn, css.btnPrimary)}
              onClick={e => {
                e.stopPropagation();
                const url = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${whatsAppMessage}`;
                window.open(url, '_blank', 'noopener noreferrer');
              }}
            >
              <a
                target="_blank"
                rel="noopener noreferrer"
                onClick={e => e.stopPropagation()}
                href={`https://api.whatsapp.com/send?phone=${phoneNumber}&text=${whatsAppMessage}`}
              >
                <FormattedMessage id="PricingPage.getStarted" />
              </a>
            </button>

            <ul className={css.features}>
              <li>
                <FormattedMessage id="PricingPage.basicFeature1" />
              </li>
              <li>
                <FormattedMessage id="PricingPage.basicFeature2" />
              </li>
              <li>
                <FormattedMessage id="PricingPage.basicFeature3" />
              </li>
              <li>
                <FormattedMessage id="PricingPage.basicFeature4" />
              </li>
              <li>
                <FormattedMessage id="PricingPage.basicFeature5" />
              </li>
              <li>
                <FormattedMessage id="PricingPage.basicFeature6" />
              </li>
              <li>
                <FormattedMessage id="PricingPage.basicFeature7" />
              </li>
              <li>
                <FormattedMessage id="PricingPage.basicFeature8" />
              </li>
              <li>
                <FormattedMessage id="PricingPage.basicFeature9" />
              </li>
              <li>
                <FormattedMessage id="PricingPage.basicFeature10" />
              </li>
              <li>
                <FormattedMessage id="PricingPage.basicFeature11" />
              </li>
            </ul>
          </div>

          {/* Pro Plan */}
          <div className={classNames(css.card, css.proCard)}>
            <div className={css.popularTag}>
              <FormattedMessage id="PricingPage.mostPopular" />
            </div>

            <h3 className={css.planName}>
              <FormattedMessage id="PricingPage.proPlan" />
            </h3>
            <p className={css.planSubtitle}>
              <FormattedMessage id="PricingPage.proPlanSubTitle" />
            </p>

            <div className={css.priceRow}>
              <span className={css.price}>
                <FormattedMessage id="PricingPage.proPrice" />
              </span>
              <span className={css.currency}>
                <FormattedMessage id="PricingPage.currencyPerMonth" />
              </span>
            </div>

            <button
              className={classNames(css.btn, css.btnPrimary)}
              onClick={e => {
                e.stopPropagation();
                const url = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${whatsAppMessage}`;
                window.open(url, '_blank', 'noopener noreferrer');
              }}
            >
              <a
                target="_blank"
                rel="noopener noreferrer"
                onClick={e => e.stopPropagation()}
                href={`https://api.whatsapp.com/send?phone=${phoneNumber}&text=${whatsAppMessage}`}
              >
                <FormattedMessage id="PricingPage.getStarted" />
              </a>
            </button>

            <ul className={css.features}>
              <li>
                <FormattedMessage id="PricingPage.proFeature1" />
              </li>
              <li>
                <FormattedMessage id="PricingPage.proFeature2" />
              </li>
              <li>
                <FormattedMessage id="PricingPage.proFeature3" />
              </li>
              <li>
                <FormattedMessage id="PricingPage.proFeature4" />
              </li>
              <li>
                <FormattedMessage id="PricingPage.proFeature5" />
              </li>
              <li>
                <FormattedMessage id="PricingPage.proFeature6" />
              </li>
              <li>
                <FormattedMessage id="PricingPage.proFeature7" />
              </li>
            </ul>
          </div>
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

const mapStateToProps = state => {
  const { currentUser } = state.user;
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const PricingPage = compose(connect(mapStateToProps))(PricingPageComponent);

export default PricingPage;
